/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-color-literals */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';

const VisitReport = ({ notes = [], plan_npd = [] }) => {
  const SectionHeader = ({ title }) => (
    <View style={styles.sectionHeader}>
      <SociollaText type="bold" style={styles.sectionHeaderText}>
        {title}
      </SociollaText>
    </View>
  );

  const CardItem = ({ text, accentColor }) => (
    <View style={styles.card}>
      <View style={[styles.cardAccent, { backgroundColor: accentColor }]} />
      <View style={styles.cardSection}>
        <SociollaText style={styles.cardSectionLabel}>Notes</SociollaText>
        <View style={styles.cardNotesBubble}>
          <SociollaText style={styles.cardNoteText}>{text || '-'}</SociollaText>
        </View>
      </View>
    </View>
  );

  const EmptyState = ({ message }) => (
    <View style={styles.emptyState}>
      <SociollaText style={styles.emptyStateText}>{message}</SociollaText>
    </View>
  );

  return (
    <View testID="todo-visit-report-container" style={styles.container}>
      <View style={styles.section}>
        <SectionHeader title="Visit Report" />
        {notes?.length ? (
          notes.map((item, idx) => (
            <CardItem key={idx} text={item.text} accentColor={Colors.blue0} />
          ))
        ) : (
          <EmptyState message="No visit report available" />
        )}
      </View>

      <View style={styles.section}>
        <SectionHeader title="Plan for Next Visit" />
        {plan_npd?.length ? (
          plan_npd.map((item, idx) => (
            <CardItem key={idx} text={item.text} accentColor={Colors.orange0} />
          ))
        ) : (
          <EmptyState message="No plan available" />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 15,
  },
  section: {
    marginBottom: 28,
  },
  sectionHeader: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  sectionHeaderText: {
    fontSize: 13,
    color: Colors.blue1,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  card: {
    width: '100%',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    overflow: 'hidden',
    marginBottom: 12,
  },
  cardAccent: {
    height: 4,
    width: '100%',
  },
  cardSection: {
    paddingHorizontal: 14,
    paddingVertical: 10,
  },
  cardSectionLabel: {
    fontSize: 11,
    color: Colors.grey1,
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  cardNotesBubble: {
    backgroundColor: Colors.grey17,
    borderRadius: 6,
    padding: 10,
  },
  cardNoteText: {
    fontSize: 12,
    color: Colors.grey14,
    lineHeight: 18,
  },
  emptyState: {
    paddingVertical: 24,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderStyle: 'dashed',
  },
  emptyStateText: {
    color: Colors.grey1,
    fontSize: 13,
  },
});

VisitReport.propTypes = {
  notes: PropTypes.array,
  plan_npd: PropTypes.array,
};

export default VisitReport;
